import React from 'react';
import { Switch, SwitchProps, styled } from '@mui/material';
import styleVariables from '../styles/styleVariables';

const CAppSwitch = (props: SwitchProps) => {
	if (props.color === 'secondary') {
		return <IOSSwitchSecondary size={props.size} {...props} />;
	} else {
		return <IOSSwitch size={props.size} {...props} />;
	}
};

const IOSSwitch = styled((props: SwitchProps) => (
	<Switch size={props.size} focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 50,
	height: 26,
	padding: 0,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 4,
		transitionDuration: '300ms',

		'&.Mui-checked': {
			transform: 'translateX(22px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				backgroundColor: '#1A2B48',
				opacity: 1,
				borderColor: 'white',
				borderStyle: 'solid',
				borderWidth: '1px',
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.5,
				borderColor: '#2e4160',
				borderStyle: 'solid',
				borderWidth: '1px',
			},
		},
		// '&.Mui-focusVisible .MuiSwitch-thumb': {
		//   color: '#33cf4d',
		//   border: '6px solid #fff',
		// },
		'&.Mui-disabled .MuiSwitch-thumb': {
			color: theme.palette.mode === 'light' ? theme.palette.grey[800] : '#2e4160',
		},
	},
	'& .MuiSwitch-thumb': {
		boxSizing: 'border-box',
		width: 18,
		height: 18,
	},
	'& .MuiSwitch-track': {
		borderRadius: 26 / 2,
		backgroundColor: '#1A2B48',
		opacity: 1,
		borderColor: 'white',
		borderStyle: 'solid',
		borderWidth: '1px',
		transition: theme.transitions.create(['background-color'], {
			duration: 500,
		}),
	},
}));

const IOSSwitchSecondary = styled((props: SwitchProps) => (
	<Switch size={props.size} focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 50,
	height: 26,
	padding: 0,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 4,
		transitionDuration: '300ms',

		'&.Mui-checked': {
			transform: 'translateX(22px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				backgroundColor: styleVariables.secondaryColor,
				opacity: 1,
				borderColor: 'white',
				borderStyle: 'solid',
				borderWidth: '1px',
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.5,
				borderColor: '#2e4160',
				borderStyle: 'solid',
				borderWidth: '1px',
			},
		},
		// '&.Mui-focusVisible .MuiSwitch-thumb': {
		//   color: '#33cf4d',
		//   border: '6px solid #fff',
		// },
		'&.Mui-disabled .MuiSwitch-thumb': {
			color: theme.palette.mode === 'light' ? theme.palette.grey[800] : '#2e4160',
		},
	},
	'& .MuiSwitch-thumb': {
		boxSizing: 'border-box',
		width: 18,
		height: 18,
	},
	'& .MuiSwitch-track': {
		borderRadius: 26 / 2,
		backgroundColor: styleVariables.secondaryColor,
		opacity: 1,
		borderColor: 'white',
		borderStyle: 'solid',
		borderWidth: '1px',
		transition: theme.transitions.create(['background-color'], {
			duration: 500,
		}),
	},
}));

export default CAppSwitch;
